import React, { useRef } from "react";
import { Button } from "@mui/material";
import UploadFileTwoToneIcon from "@mui/icons-material/UploadFileTwoTone";
import styles from '../../styles.module.css';

const ExcelUploadButton = ({ handleFileChange, sx = {}, className = '' }) => {
    const fileInputRef = useRef(null);

    const handleUpload = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <Button className={`${styles.filtericon} ${className}`} sx={sx}>
            <input
                ref={fileInputRef}
                type="file"
                name="file"
                style={{ display: "none" }}
                onChange={handleFileChange}
                accept=".xlsx,.xls,.csv"
            />
            <UploadFileTwoToneIcon
                onClick={handleUpload}
                sx={{ cursor: "pointer", fontSize: 28, color: "#ffffff" }}
            />
        </Button>
    );
};

export default ExcelUploadButton;